<template>
  <div>
    <h1 class="page-header">{{ $t('orgChartLevel.pageTitle') }}</h1>
    <div>
      <ts-card>
        <ts-card-wrapper>
          <div class="d-flex justify-content-between">
            <ts-button color="info" outline @click="showForm()">{{ $t('addNew') }}</ts-button>
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px;" />
          </div>
        </ts-card-wrapper>
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'company.company_name_en'
          }"
        >
          <template v-slot="{ record }">
            <td></td>
            <td>{{ record.level_description }}</td>
            <td>{{ record.level_counter }}</td>
            <td class="text-center">
              <a href="#" v-tooltip="'Edit'" class="text-primary mr-2" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="'Delete'"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
      </ts-card>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form.vue'

export default {
  name: 'org-chart-level',
  components: { FormComponent },
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/orgChartLevel', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.orgChartLevel.search
      },
      set(newValue) {
        this.$store.commit('hr/orgChartLevel/SET_SEARCH', newValue)
        this.$store.commit('hr/orgChartLevel/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: '' },
        { name: this.$t('orgChartLevel.levelDescription') },
        { name: this.$t('orgChartLevel.levelCounter') },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/orgChartLevel/fetch', {
          ...attributes,
          include: 'company'
        })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.showForm(record)
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('hr/orgChartLevel/destroy', record.org_id)
          .then(response => {
            this.$store.dispatch('hr/orgChartLevel/fetch').then(() => {
              this.$toasted.success(response.message)
              record._deleting = false
            })
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData,
          companies: this.$route.params.companies
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/orgChartLevel/RESET_STATE')
    next()
  }
}
</script>
